import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
  toast,
} from "@devhop/ui";
import { Loader2 } from "lucide-react";
import { useState } from "react";
import { useOpenShiftMutation } from "../api/queries";

type OpenShiftDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  branchId: string;
  deviceId: string;
  onSuccess?: () => void;
};

export function OpenShiftDialog({
  open,
  onOpenChange,
  branchId,
  deviceId,
  onSuccess,
}: OpenShiftDialogProps) {
  const [openingFloat, setOpeningFloat] = useState<string>("0");
  const openShiftMutation = useOpenShiftMutation();

  const handleSubmit = async () => {
    const floatValue = Number.parseFloat(openingFloat);
    if (Number.isNaN(floatValue) || floatValue < 0) {
      toast.error("ເງິນຕົ້ນຕ້ອງເປັນຕົວເລກທີ່ບໍ່ນ້ອຍກວ່າ 0");
      return;
    }

    try {
      await openShiftMutation.mutateAsync({
        branchId,
        deviceId,
        openingFloat: floatValue,
      });

      toast.success("ເປີດກະ ສຳເລັດແລ້ວ");
      setOpeningFloat("0");
      onSuccess?.();
      onOpenChange(false);
    } catch (error) {
      toast.error(
        error instanceof Error ? error.message : "ເກີດຂໍ້ຜິດພາດໃນການເປີດກະ",
      );
    }
  };

  const handleClose = () => {
    if (openShiftMutation.isPending) return;
    setOpeningFloat("0");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>ເປີດກະ</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <Label htmlFor="openingFloat">ເງິນຕົ້ນ (Opening Float)</Label>
            <Input
              id="openingFloat"
              type="number"
              min="0"
              step="0.01"
              value={openingFloat}
              onChange={(e) => setOpeningFloat(e.target.value)}
              placeholder="0.00"
              className="mt-2"
            />
            <p className="mt-1 text-muted-foreground text-xs">
              ເງິນສົດທີ່ວາງໃນລີນຊັກເກັບເງິນເວລາເປີດກະ
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={handleClose}
            disabled={openShiftMutation.isPending}
          >
            ຍົກເລີກ
          </Button>
          <Button onClick={handleSubmit} disabled={openShiftMutation.isPending}>
            {openShiftMutation.isPending ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                ກຳລັງເປີດ...
              </>
            ) : (
              "ເປີດກະ"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
